import { CustomYup, isValidInternationalPhone } from '@/utils'

const phoneValidation = CustomYup.string()
  .nullable()
  .test(
    'international-phone-format',
    'Teléfono inválido. Usa formato internacional, por ejemplo: +56912345678',
    (value) => isValidInternationalPhone(value)
  )

export const validationSchema = CustomYup.object({
  document_number: CustomYup.string().rut(),
  phone: phoneValidation,
  legal_representative_attributes: CustomYup.object({
    phone: phoneValidation
  }),
  safety_information: CustomYup.object({
    safety_manager: CustomYup.object({
      phone: phoneValidation
    })
  }).nullable(),
  user_attributes: CustomYup.object({
    id: CustomYup.number().nullable(),
    has_local_document_number: CustomYup.boolean(),
    phone: phoneValidation,
    document_number: CustomYup.string().when('id', {
      is: (id) => !id,
      then: () =>
        CustomYup.string().when('has_local_document_number', {
          is: false,
          then: () =>
            CustomYup.string()
              .matches(/^[0-9a-zA-Z]+$/, 'Número de documento inválido')
              .required('Número de documento es requerido'),
          otherwise: () =>
            CustomYup.string()
              .rut()
              .required('Número de documento es requerido')
        }),
      otherwise: () => CustomYup.string().nullable()
    })
  })
})
